import { useCallback, useEffect, useState } from 'react'
import { getReferralStatus, getReferralSystem } from '../api/getApi'
import { useDispatch, useSelector } from 'react-redux'
import { setReferralData } from '../redux/billing/billing.action'

const UseReferral = (props) => {
  const { isAuth } = useSelector(({ authentication }) => authentication)
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    try {
      const { is_active } = await getReferralSystem()
      setIsLoading(false)
      if (!is_active) {
        dispatch(setReferralData(null))
        return
      }
      const data = await getReferralStatus()
      dispatch(setReferralData(data))
    } catch (error) {
      setIsLoading(false)
      console.error('Failed to fetch referral status:', error)
    }
  }, [dispatch])

  useEffect(() => {
    if (isAuth) fetchData()
  }, [fetchData, isAuth])

  return { fetchData, isLoading }
}
export default UseReferral
